<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
a:hover{text-decoration: none;}
.bgc-f{background: #FFFFFF;}
.l{float: left;}
.r{float: right;}
.w100{width: 100%;}
.w12{width: 1200px;margin: 0 auto;overflow: hidden;height: 100%;min-width: 1200px;}
</style>



// WEBPACK FOOTER //
// src/App.vue